import { Link, useLocation } from "react-router";
import { Button } from "../ui/index.tsx";
import { Logo } from "../layouts.tsx";

export default function NotFound() {
  const { pathname, search } = useLocation();
  return (
    <div className="relative grid min-h-screen place-items-center overflow-hidden px-4">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-80 w-[40rem] -translate-x-1/2 rounded-full bg-accent/10 blur-3xl" />
      {/* Scanlines plus one slow bright band sweeping down the screen. */}
      <div className="scanlines pointer-events-none absolute inset-0" aria-hidden />
      <div className="pointer-events-none absolute inset-0 animate-scan bg-[linear-gradient(to_bottom,transparent_42%,rgb(255_61_79/0.07)_50%,transparent_58%)]" aria-hidden />
      <div className="relative animate-rise text-center">
        <Logo className="mb-10 justify-center text-lg" />
        <div className="kicker mb-2 text-accent">// signal lost</div>
        <div className="glitch font-display text-8xl font-semibold tracking-tight sm:text-9xl" role="img" aria-label="404">
          <span className="text-accent" aria-hidden>404</span>
          <span className="glitch-a text-ember" aria-hidden>404</span>
          <span className="glitch-b text-fg" aria-hidden>404</span>
        </div>
        <h1 className="mt-4 text-xl font-semibold">This page doesn't exist</h1>
        <p className="mt-1 text-sm text-muted">The link may be old, or the address was mistyped.</p>
        <code className="mx-auto mt-5 block max-w-md break-all rounded-lg border border-line bg-surface/80 px-3 py-2 font-mono text-xs text-muted">
          <span className="text-faint">GET </span>{pathname}{search}
        </code>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/"><Button variant="primary">Back to home</Button></Link>
          <Link to="/games"><Button>Games</Button></Link>
          <Link to="/status"><Button>Status</Button></Link>
        </div>
      </div>
    </div>
  );
}
